import { ArrowLeft, Home } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
  backPath?: string; // Optional override for back navigation
  children?: React.ReactNode; // For action buttons on the right
}

export default function PageHeader({ title, subtitle, icon, backPath, children }: PageHeaderProps) {
  const navigate = useNavigate();
  const { role } = useAuth();

  const getDashboardPath = () => {
    switch (role) {
      case 'ADMIN': return '/admin/dashboard';
      case 'AGENT': return '/agent/dashboard';
      case 'OWNER': return '/owner/dashboard';
      case 'CONTRACTOR': return '/contractor/dashboard';
      case 'RENTER':
      default: return '/dashboard';
    }
  };

  const handleBack = () => {
    if (backPath) {
      navigate(backPath);
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="mb-8">
      {/* Navigation Icons */}
      <div className="flex items-center gap-2 mb-4">
        <button
          onClick={handleBack}
          className="p-2 text-gray-400 hover:text-primary hover:bg-gray-100 rounded-lg transition-colors"
          title="Go back"
        >
          <ArrowLeft className="w-5 h-5" />
        </button>
        <button
          onClick={() => navigate(getDashboardPath())}
          className="p-2 text-gray-400 hover:text-primary hover:bg-gray-100 rounded-lg transition-colors"
          title="Go to dashboard"
        >
          <Home className="w-5 h-5" />
        </button>
      </div>

      {/* Title Section */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          {icon && <div className="text-primary">{icon}</div>}
          <div>
            <h1 className="text-3xl font-bold" style={{ color: '#0C4432' }}>{title}</h1>
            {subtitle && <p className="text-gray-600">{subtitle}</p>}
          </div>
        </div>
        {children && <div className="flex items-center gap-3">{children}</div>}
      </div>
    </div>
  );
}

